<template>
  <div id="app">
    <Header></Header>
    <router-view></router-view>
    <Record></Record>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Record from "@/components/Record.vue";
export default {
  name: "APP",
  components: {
    Header,
    Record
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
</style>
